import React, { useState } from 'react';
import { REACT_APP_DISCORD_BOT_ENDPOINT } from '../config/constants'; 

// Importando providers da mesma forma que no CreateVPS
const PROVIDERS = (() => {
  try {
    // process.env.REACT_APP_PROVIDER pode vir com aspas simples ou duplas, então normalizamos
    let raw = process.env.REACT_APP_PROVIDER || '';
    if (raw.startsWith("'")) raw = raw.slice(1, -1); // remove aspas simples externas
    return JSON.parse(raw);
  } catch {
    return [];
  }
})();

const initialState = {
  provider: '',
  selectedHost: '',
  reportType: ''
};

const availableReports = [
  { value: 'data_transfer_out', label: 'Data transfer out' },
  { value: 'uptime', label: 'Uptime' }
];

export default function ReportsForm({ authToken }) {
  const [form, setForm] = useState(initialState);
  const [submitted, setSubmitted] = useState(false);
  const [responseMsg, setResponseMsg] = useState('');
  const [resourceList, setResourceList] = useState([]);
  const [loadingResource, setLoadingResource] = useState(false);

  // Função para carregar lista de recursos
  const loadResourcesList = async (tipoRecurso, provider) => {
    try {
      setLoadingResource(true);
      const response = await fetch(REACT_APP_DISCORD_BOT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
          command: 'opt',
          function: 'list-hosts-modify',
          tipoRecurso: tipoRecurso,
          filter: 'provider=' + provider
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setResourceList(data);
    } catch (error) {
      console.error('Erro ao carregar lista de recursos:', error);
      setResourceList([]);
    } finally {
      setLoadingResource(false);
    }
  };

  // Função para tratar mudanças nos selects
  const handleProviderChange = (e) => {
    const selectedProvider = e.target.value;
    setForm(prev => ({
      ...prev,
      provider: selectedProvider,
      selectedHost: '', // Limpa o host quando muda o provider
      reportType: '' // Limpa o tipo de relatório quando muda o provider
    }));
    
    // Se o provider for apiki-aws-main, carrega a lista de recursos EC2
    if (selectedProvider === 'apiki-aws-main' || selectedProvider === 'apiki-oci-main') {
      loadResourcesList('EC2', selectedProvider);
    } else {
      setResourceList([]);
    }
  };

  const handleHostChange = (e) => {
    setForm(prev => ({
      ...prev,
      selectedHost: e.target.value,
      reportType: '' // Limpa o tipo de relatório quando muda o host
    }));
  };

  const handleReportTypeChange = (e) => {
    setForm(prev => ({
      ...prev,
      reportType: e.target.value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    fetch(REACT_APP_DISCORD_BOT_ENDPOINT, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${authToken}`
      },
      body: JSON.stringify({
        command: 'submit',
        data: {
          form: 'reports',
          provider: form.provider,
          selectedHost: form.selectedHost,
          reportType: form.reportType
        }
      }),
    })
      .then((res) => res.text())
      .then((msg) => {
        setSubmitted(true);
        setResponseMsg(msg);
      });
  };

  // Preparar providers no mesmo formato que CreateVPS
  const CloudProvider = PROVIDERS.map((provider) => ({
    text: provider,
    value: provider,
    selected: false
  }));

  if (submitted) {
    let content;
    try {
      const parsed = JSON.parse(responseMsg);
      content = (
        <div className="json-response-list">
          {Object.entries(parsed).map(([key, value]) => (
            <div key={key} style={{ marginBottom: '0.5em' }}>
              <strong>{key}:</strong> <span>{String(value)}</span>
            </div>
          ))}
        </div>
      );
    } catch {
      content = <p>{responseMsg}</p>;
    }
    return (
      <div className="dynamic-form">
        <div className="success-message">
          {content}
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="dynamic-form">
      <div className="form-group">
        <label className="form-label">Provider</label>
        <select 
          value={form.provider} 
          onChange={handleProviderChange}
          className="form-select"
        >
          <option value="">Selecione o Provider</option>
          {CloudProvider.map((provider) => (
            <option key={provider.value} value={provider.value}>
              {provider.text}
            </option>
          ))}
        </select>
      </div>

      {loadingResource && (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p className="loading-text">Carregando recursos...</p>
        </div>
      )}

      {(form.provider === 'apiki-aws-main' || form.provider === 'apiki-oci-main') && resourceList.length > 0 && (
        <div className="form-group">
          <label className="form-label">Servidor</label>
          <select 
            value={form.selectedHost} 
            onChange={handleHostChange}
            className="form-select"
          >
            <option value="">Selecione um recurso</option>
            {resourceList.map((resource) => (
              <option key={resource.value} value={resource.value}>
                {resource.text}
              </option>
            ))}
          </select>
        </div>
      )}

      {form.selectedHost && (form.provider === 'apiki-aws-main' || form.provider === 'apiki-oci-main') && (
        <div className="form-group">
          <label className="form-label">Tipo de Relatório</label>
          <select 
            value={form.reportType} 
            onChange={handleReportTypeChange}
            className="form-select"
          >
            <option value="">Selecione o tipo de relatório</option>
            {availableReports.map((report) => (
              <option key={report.value} value={report.value}>
                {report.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="form-actions">
        <button 
          type="submit" 
          disabled={!form.provider || ((form.provider === 'apiki-aws-main' || form.provider === 'apiki-oci-main') && (!form.selectedHost || !form.reportType))}
          className="submit-button"
        >
          Gerar Relatório
        </button>
      </div>

      {submitted && (
        <div className="success-message">
          <span className="success-icon">✓</span>
          <p>Relatório gerado com sucesso!</p>
        </div>
      )}
    </form>
  );
}
